import domain from '../domain';

export const onRadarRotate = domain.event<number>();
